<template>
  <v-form v-model="valid" ref="form" lazy-validation>
    <v-card flat>
      <v-card-title> <v-icon>mdi-phone</v-icon> {{ titre }} </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12">
            <vue-tel-input-vuetify
              autofocus
              enabledCountryCode="true"
              mode="international"
              :preferredCountries="['FR']"
              defaultCountry="FR"
              disabledFetchingCountry
              filled
              :rules="[obligatoireRule(), serveurRule(`${itemPath}.numero`)]"
              v-model="numero"
              label="Numéro"
              prepend-inner-icon="mdi-phone"
            ></vue-tel-input-vuetify>
          </v-col>
          <v-col cols="12">
            <v-text-field
              dense
              filled
              v-if="showHeader"
              :rules="[serveurRule(`${itemPath}.codePoste`)]"
              v-model="codePoste"
              label="Code poste"
            />
          </v-col>
          <v-col cols="12">
            <v-combobox
              dense
              filled
              :rules="[obligatoireRule(), serveurRule(`${itemPath}.libelle`)]"
              v-model="libelle"
              :items="telephones"
              label="Libellé"
            />
          </v-col>
          <v-col cols="6">
            <v-checkbox
              hide-details
              dense
              v-model="confidentiel"
              label="Confidentiel"
            />
          </v-col>
          <v-col cols="6">
            <v-checkbox
              hide-details
              dense
              v-model="smsAccepte"
              label="SMS Accepté"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn text color="primary" @click="valider()">Ok</v-btn>
        <v-btn text @click="annuler()">Annuler</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { copieTelephone, getmask } from './telephoneUtil.js';
import ServeurRule from '@/plugins/mixins/ServeurRule';
import ValidationRules from '@/plugins/mixins/ValidationRules';
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue';

export default {
  mixins: [ServeurRule, ValidationRules],
  components: {
    VueTelInputVuetify,
  },
  inject: ['errors'],
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Object,
    },
    telephones: {
      type: Array,
      default: () => ['Téléphone professionnel', 'Téléphone portable'],
    },
    titre: {
      type: String,
    },
    itemPath: {
      type: String,
      default: '',
    },
  },
  data() {
    const data = copieTelephone({}, this.value);
    data.valid = true;
    return data;
  },
  watch: {
    value(newValue) {
      copieTelephone(this, newValue);
      this.$refs.form.resetValidation();
    },
  },
  methods: {
    getmask,
    valider() {
      this.validationServeur = false;
      const validate = this.$refs.form.validate();
      this.validationServeur = true;
      if (validate) {
        var telephone = copieTelephone({}, this);
        telephone.numero = telephone.numero.replaceAll(' ', '');

        this.$emit('input', telephone);
        this.$emit('change');
      }
    },

    annuler() {
      this.$emit('annuler');
    },
  },
};
</script>
